import React, { useEffect } from "react";
import styles from "./FirstAid.module.css";
import { Button, IconButton } from "@material-ui/core";
import Row from '../ArticleComponents/Row';
import FirstAidLandscape from "../../../assets/firstAid.svg";
import ArticleCoverAndHeader from "../ArticleComponents/ArticleCoverAndHeader";

function FirstAid() {

  const rows = [{
    heading:"Rest at home",
    image_url:"https://drive.google.com/thumbnail?id=1crqRmgnP--f0jKvywOk6YEf7UQ7crY0G",
    listItem:["Your body will need plenty of sleep and rest to fight the infection.",
    "Go to bed, drink plenty of hydrating fluids, and the majority of people will make a full recovery within 10 to 14 days.",
    "Take painkillers, throat lozenges, cough medication, and paracetamol if you need them, just as you would if you had a regular cold or flu.",
    "You can also consult a family doctor for online consultation."]
  },{
    heading:"Stay hydrated",
    image_url:"https://drive.google.com/thumbnail?id=12e9rP06mB2SDSfz-YvjdWNBNduFlieAb",
    listItem:["It is vitally important to drink plenty of water, even if you are not thirsty.",
    "Dehydration occurs when your body loses more water than it takes in. This is very common when you are ill. A fever also makes you sweat.",
    "A small minority of people with the coronavirus note diarrhoea as a symptom. This can lead to a rapid loss of fluids and electrolytes as well.",
    "Drink plenty of water, juice, or soup. Avoid coffee and alcohol as these are diuretics and will further dehydrate you."]
  },{
    heading:"Prevent spread",
    image_url:"https://drive.google.com/thumbnail?id=1hEOpnExMlC4F2x0lFDLf0pYBb8ZOb0mD",
    listItem:["It is important to isolate yourself in a well_ventilated room, with the windows open. If you live with other people, sleep in a separate bed or space, and use a different bathroom if possible.",
    "Wash your hands regularly for at least 20 seconds, especially after coughing or sneezing and before eating or drinking. If soap and water are not available, clean your hands with an alcohol_based hand sanitizer that contains at least 60% alcohol.",
    "If you have a mask, wear it when coughing, and anyone caring for you should also wear a mask to protect themselves. Once wet, masks will no longer provide a protective barrier.",
    "Avoid public areas and transportation. Stay away from anyone who is elderly or with underlying health conditions which could be easily and seriously infected."]
  }]

  //"https://drive.google.com/thumbnail?id=1kc-5Mu_JrS1m24QO3HHiGMZRVgoiYsej",
  //    "https://drive.google.com/thumbnail?id=1xumlgWd4VCXWRE2q31O_txv_kPbDUa1G",

  useEffect(() => {
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  })

  return (
    <ArticleCoverAndHeader readTime={5} title="First Aid At Home" author="Rohan Gupta" authorLink="https://www.instagram.com/rohan_g1572/" previousGuide="/help-on-twitter" nextGuide="/how-it-spreads">

        <img
          className={styles.articleFirstImage}
          src={FirstAidLandscape}
          alt="first_landscape_img"
        />

        <div className={styles.introPara}>
          <h3>Recognizing possible signs and symptoms of coronavirus:</h3>

          <p>
            If you have a new persistent cough or a{" "}
            <span className={styles.highlight}>fever above 100 F</span>, you
            should{" "}
            <span className={styles.highlight}>self-isolate for 14 days</span>.
            During this time, you are particularly contagious. You no longer
            need to be tested for the virus; only those requiring hospital
            treatment will be tested.
            <br /> <br />
            <span className={styles.highlight}> Call 1075 </span> if you become
            substantially worse or if you get different symptoms after seven
            days.
            <br /> <br />
            In some cases, people tend to contain the virus in their bodies, but
            they don't show any symptoms. These people are known as{" "}
            <span className={styles.highlight}> Asymptomatic carriers </span> of
            the virus. Suppose anyone around you tested positive for the virus
            or has symptoms, you should quarantine yourself or get tested for
            confirmation.
          </p>
        </div>
        
        {
            rows.map((row)=>(
                <Row row={row}/>
            ))
        }

        <div className={styles.rowCover}>
          <h3>Breathing excercises to do at Home</h3>
          <div className={styles.row}>
            <div className={styles.column}>
              <img className={styles.image} src="https://drive.google.com/thumbnail?id=18kptCLctYNVLyY6XxK56Y5dnQmV8Tldy" alt="second_img" />
            </div>

            <div className={styles.column}>
              <ul className={styles.list}>
                <li>
                  Breathe {""}
                  <span className={styles.highlight}>deeply and slowly</span>.
                  Breathe in through your nose and breathe out through your
                  mouth.
                </li>
                <li>
                  <span className={styles.highlight}>Inhale </span> – Breathe in
                  slowly through your nose to the count of 1_2.
                </li>
                <li>
                  <span className={styles.highlight}>Exhale</span> – Breathe out
                  (like blowing a candle) slowly through your mouth to the count
                  of 1_2_3_4.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className={styles.rowCover}>
          <h3>Prone Positioning</h3><br /><br /><br />
          <div className={styles.img}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/cCkHPYpwg2g"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <br />

          <div className={styles.column}>
            <ul className={styles.list}>
              <li>
                <span className={styles.highlight}>Correct Method:</span>
                <ol className={styles.list}>
                  <li>Lie on your stomach</li>
                  <li>Legs straight out</li>
                  <li>Put a pillow under your chest</li>
                  <li>Turn your head to the side</li>
                  <li>Put your hand up towards the side of your head</li>
                  <li>Take deep, long breaths as you’re in the position</li>
                  <li>Do this for 30 minutes to 2 hours</li>
                </ol>
              </li>
              <li>
                <span className={styles.highlight}>
                  Left Lateral Recumbent Position:
                </span>{" "}
                Lie on your left side, arm below the head, legs parallel for 30
                minutes to 2 hours.
              </li>
              <li>
                <span className={styles.highlight}>
                  Right Lateral Recumbent Position:
                </span>{" "}
                Lie on your right side, arm below the head, legs parallel for 30
                minutes to 2 hours.
              </li>
              <li>
                <span className={styles.highlight}>Sitting up:</span> Sit
                Straight up, legs straight out for 30 minutes to 2 hours.
              </li>
            </ul>
          </div>
        </div>
      </ArticleCoverAndHeader>
  );
}

export default FirstAid;
